import { Box, Container, Typography } from '@mui/material';
import { ChallengeManagement } from 'components/templates';

export const ChallengesView = () => {
  return (
    <Container>
      <Box>
        <Typography variant="h4" gutterBottom sx={{ textAlign: 'left' }}>
          Functional Challenges
        </Typography>
      </Box>
      <ChallengeManagement />
    </Container>
  );
};
